import { Button, Form, Input, message } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { changePassword } from "../../../../../controller/services/settings";
import useFormValidation from "../../../../../hooks/useFormValid";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const ChangePassword = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { formValid, handleValuesChange, formValues } = useFormValidation(form);
  const dispatch = useDispatch();

  const onFinish = (values) => {
    dispatch(setLoading(true));
    const payload = {
      oldPassword: values.password,
      newPassword: values.confirmPassword,
    };
    changePassword(payload)
      .then((resp) => {
        message.success(resp?.message?.[i18n.language]);
      })
      .catch((err) => {
        message.error(err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <RightSideSettingsWrapper>
      <Form
        className="common-form"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        form={form}
        onValuesChange={handleValuesChange}
      >
        <div className="row settings-details-row">
          <div className="col-12 reset-password-form">
            <Form.Item
              label={false}
              name="password"
              rules={[
                {
                  required: true,
                  message: t("errors.password"),
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: t("errors.validPass"),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value.length <= 50) {
                      return Promise.resolve();
                    }

                    return Promise.reject(new Error(t("errors.maxLimit")));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues?.password
                        ? "/assets/images/icons/lock-icon-primary.svg"
                        : "/assets/images/icons/lock-icon.svg"
                    }
                  />
                }
                iconRender={(visible) =>
                  visible ? (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/eye-icon-primary.svg"
                    />
                  ) : (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/hide-eye-icon.svg"
                    />
                  )
                }
                placeholder={t("settings.oldPass")}
              />
            </Form.Item>
            <Form.Item
              label={false}
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: t("errors.password"),
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: t("errors.validPass"),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (getFieldValue("password") === value) {
                      return Promise.reject(
                        new Error(
                          t("errors.matchWithCurrPass")
                        )
                      );
                    }
                    if (value.length <= 50) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(new Error(t("errors.maxLimit")));
                    }
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues?.confirmPassword
                        ? "/assets/images/icons/lock-icon-primary.svg"
                        : "/assets/images/icons/lock-icon.svg"
                    }
                  />
                }
                iconRender={(visible) =>
                  visible ? (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/eye-icon-primary.svg"
                    />
                  ) : (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/hide-eye-icon.svg"
                    />
                  )
                }
                placeholder={t("settings.newPass")}
              />
            </Form.Item>
            <Form.Item
              label={false}
              name="newPassword"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: t("errors.password"),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("confirmPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("errors.matchPass")));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={
                  <img
                    alt=""
                    className="img-fluid"
                    src={
                      formValues?.confirmPassword
                        ? "/assets/images/icons/lock-icon-primary.svg"
                        : "/assets/images/icons/lock-icon.svg"
                    }
                  />
                }
                iconRender={(visible) =>
                  visible ? (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/eye-icon-primary.svg"
                    />
                  ) : (
                    <img
                      alt=""
                      className="img-fluid"
                      src="/assets/images/icons/hide-eye-icon.svg"
                    />
                  )
                }
                placeholder={t("settings.confirmPass")}
              />
            </Form.Item>
          </div>
        </div>
        <div className="row mx-0 footer-settings-row">
          <Button
            type="primary"
            htmlType="submit"
            disabled={
              !formValues.password ||
              !formValues.confirmPassword ||
              !formValues.newPassword ||
              !formValid
            }
          >
            {t("update")}
          </Button>
        </div>
      </Form>
    </RightSideSettingsWrapper>
  );
};

export default ChangePassword;
